import {
    Component,
    ElementRef,
    OnInit,
    ViewChild,
    AfterViewInit,
    TemplateRef,
    ChangeDetectorRef,
    EventEmitter,
    Output,
    Input,
    OnChanges
} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router, NavigationEnd } from '@angular/router';
import * as feather from 'feather-icons';
import { ToastrService } from 'ngx-toastr';
import { FileUploadModalNegoceComponent } from './file-upload-modal/file-upload-modal-negoce.component';
import { filter } from 'rxjs/operators';
import { ImportQRNegoceComponent } from './import-qr/import-qr-negoce.component';
import { EmailComposeNegoceComponent } from './email-compose/email-compose-negoce.component';
import { TaxeService, Taxe } from '../../../../parametre/taxe-tva/parametre-taxe/taxe.service';
import { CoreSidebarService } from '../../../../../../@core/components/core-sidebar/core-sidebar.service';
import { ExportService } from '../../../shared/export.service';
import {EmailService} from './email.service';
import {DocumentService} from '../../../../../services/document/document.service';
import {ActivatedRoute} from '@angular/router';
import {DateEcheanceFrequency} from '../../../../../models/document';

@Component({
    selector: 'app-parametre-bar-negoce',
    templateUrl: './parametre-bar-negoce.component.html',
    styleUrls: ['./parametre-bar-negoce.component.scss'],
})
export class ParametreBarNegoceComponent implements OnInit, AfterViewInit, OnChanges {
    private modalRef: NgbModalRef | null = null;
    @ViewChild('uploadModal') fileUploadModal!: FileUploadModalNegoceComponent;
    @ViewChild('emailMoldal') emailComposeComponent!: EmailComposeNegoceComponent;
    @ViewChild('importQR') importQRModal!: ImportQRNegoceComponent;
    @ViewChild('cachetModal') cachetModal!: TemplateRef<any>;
    @Output() documentSettingsChange = new EventEmitter<any>();
    @Output() primaryColorChange = new EventEmitter<string>();
    @Output() downloadPDFRequest = new EventEmitter<void>();
    @Output() taxesUpdated = new EventEmitter<void>();
    /** Overrides locaux (taxe_id → actif) pour les taxes avec applique_sur_tous_document === false */
    @Output() documentTaxStatutChange = new EventEmitter<{ taxId: number; statut: boolean }>();
    @Input() taxStatutDocumentOverrides: { [taxId: number]: boolean } | null = null;
    @Input() documentType: string = 'devis';
    @Input() initialSettings: any = null; // Pour recevoir les settings depuis DocumentComponent
    @Input() documentId: number | null = null; // ID du document pour charger les paramètres depuis l'API
    isSettingsPanelOpen = false;
    activeTab: 'document' | 'taxe' | 'devise' = 'document';
    isApprovePage: boolean = false;
    label: string = 'devis';
    dateValue = 1;
    dateFrequency: DateEcheanceFrequency = DateEcheanceFrequency.JOURS;
    dateEcheance: string = ''; // Date d'échéance calculée
    dataSource: 'api' | 'initialSettings' | 'localStorage' | 'default' | null = null; // Source des données chargées
    currencies = [
        { code: 'USD', name: 'Dollar des États-Unis', flag: 'US', rate: '0.33 $US' },
        { code: 'BRL', name: 'Real Brésilien', flag: 'BR', rate: '0.33 $US' },
        { code: '$6.48k', name: 'India', flag: 'IN', rate: '0.33 $US' },
        { code: '$5.12k', name: 'Australia', flag: 'AU', rate: '0.33 $US' },
        { code: '$4.45k', name: 'France', flag: 'FR', rate: '0.33 $US' },
        { code: '$3.90k', name: 'China', flag: 'CN', rate: '0.33 $US' },
    ];
    documentSettings = {
        reference: true,  // Par défaut true pour nouveau document
        quantite: true,  // Par défaut true
        unite: false,
        prixUnitaire: true,  // Par défaut true
        tva: true,  // Par défaut true
        remise: false,
        afficherMontantsTTC: false,
        afficherCodeBarres: true,  // Par défaut true
        afficherDateEcheance: false,
        afficherDateLivraison: true,  // Par défaut true
        afficherMontantTotal: true,
        afficherCoordonneesClients: true,  // Par défaut true
    };
    pieceJointe = {
        nom: true,
        taille: false,
        miseAJour: false,
    };
    primaryColor = '#134AD3';
    taxes: Taxe[] = [];
    isLoadingTaxes = false;
    filteredCurrencies = [...this.currencies];
    currencySearch = '';
    stationId = JSON.parse(localStorage.getItem('currentUser') || '{}')?.stations?.[0]?.id;

    constructor(
        private modalService: NgbModal,
        private toastr: ToastrService,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private _emailService: EmailService,
        private exportService: ExportService,
        private taxeService: TaxeService,
        private documentService: DocumentService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.filterCurrencies();
        this.checkRoute();
        this.loadTaxes();
        // Essayer de charger depuis l'API si documentId est disponible
        if (this.documentId) {
            this.loadParametrageFromAPI();
        } else {
            this.loadDocumentSettings();
        }
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.checkRoute();
            });
    }
    
    ngOnChanges(changes: any): void {
        // Si les settings initiaux changent depuis le parent, les charger
        if (changes.initialSettings && changes.initialSettings.currentValue) {
            this.loadDocumentSettings();
        }
        // Si documentId change, charger depuis l'API
        if (changes.documentId && changes.documentId.currentValue) {
            this.loadParametrageFromAPI();
        }
    }
    
    private loadDocumentSettings(): void {
        // Priorité 1: Utiliser les settings passés depuis le parent
        if (this.initialSettings) {
            this.dataSource = 'initialSettings';
            this.syncSettingsFromDocument(this.initialSettings);
           // this.logDataSource();
            return;
        }
        
        // Priorité 2: Charger depuis localStorage
        const saved = localStorage.getItem('documentColumnSettings');
        if (saved) {
            try {
                const parsed = JSON.parse(saved);
                this.dataSource = 'localStorage';
                this.syncSettingsFromDocument(parsed);
               // this.logDataSource();
            } catch (e) {
                // En cas d'erreur, utiliser les valeurs par défaut
                this.dataSource = 'default';
                this.documentSettings = {
                    reference: true,  // Par défaut true pour nouveau document
                    quantite: true,
                    unite: false,
                    prixUnitaire: true,
                    tva: true,
                    remise: false,
                    afficherMontantsTTC: false,
                    afficherCodeBarres: true,
                    afficherDateEcheance: false,
                    afficherDateLivraison: true,
                    afficherMontantTotal: true,
                    afficherCoordonneesClients: true,
                };
               // this.logDataSource();
            }
        } else {
            // Si aucune valeur sauvegardée, utiliser les valeurs par défaut
            this.dataSource = 'default';
            this.documentSettings = {
                reference: false,  // Par défaut false
                quantite: true,
                unite: false,
                prixUnitaire: true,
                tva: true,
                remise: false,
                afficherMontantsTTC: false,
                afficherCodeBarres: true,
                afficherDateEcheance: false,
                afficherDateLivraison: true,
                afficherMontantTotal: true,
                afficherCoordonneesClients: true,
            };
            //this.logDataSource();
        }
    }
    
    /**
     * Charge les paramètres depuis l'API /api/documents/{id}/parametrage-doc
     */
    private loadParametrageFromAPI(): void {
        if (!this.documentId) {
            this.loadDocumentSettings(); // Fallback vers les autres sources
            return;
        }

        
        this.documentService.getDocumentParametrage(this.documentId).subscribe({
            next: (response) => {
                
                // Extraire les données depuis la réponse API
                const data = response?.data || response?.parametrage_doc || response;
                
                if (data) {
                    this.dataSource = 'api';
                    
                    // Extraire parametrage_doc (peut être dans data.parametrage_doc ou directement dans data)
                    const parametrageDoc = data.parametrage_doc || data;
                    
                    if (parametrageDoc) {
                        this.syncSettingsFromDocument(parametrageDoc);
                        
                        // Charger color et label depuis parametrage_doc
                        if (parametrageDoc.color) {
                            this.primaryColor = parametrageDoc.color;
                        }
                        if (parametrageDoc.label) {
                            this.documentType = parametrageDoc.label;
                            this.label = parametrageDoc.label;
                        }
                    }
                    
                    // Charger date_echeance (fréquence) et nbr_date depuis parametrage_doc
                    if (parametrageDoc.date_echeance) {
                        // Convertir la valeur string en enum si nécessaire (pour compatibilité)
                        const frequencyValue = parametrageDoc.date_echeance as string;
                        if (frequencyValue === 'jours' || frequencyValue === DateEcheanceFrequency.JOURS) {
                            this.dateFrequency = DateEcheanceFrequency.JOURS;
                        } else if (frequencyValue === 'mois' || frequencyValue === DateEcheanceFrequency.MOIS) {
                            this.dateFrequency = DateEcheanceFrequency.MOIS;
                        } else if (frequencyValue === 'annee' || frequencyValue === 'années' || frequencyValue === DateEcheanceFrequency.ANNEE) {
                            this.dateFrequency = DateEcheanceFrequency.ANNEE;
                        } else {
                            this.dateFrequency = DateEcheanceFrequency.JOURS; // Valeur par défaut
                        }
                    }
                    if (parametrageDoc.nbr_date !== undefined && parametrageDoc.nbr_date !== null) {
                        this.dateValue = parametrageDoc.nbr_date;
                    }
                    // Fallback: si nbr_date est encore au niveau racine (pour compatibilité)
                    if (data.nbr_date !== undefined && data.nbr_date !== null && (parametrageDoc.nbr_date === undefined || parametrageDoc.nbr_date === null)) {
                        this.dateValue = data.nbr_date;
                    }

                  //  this.logDataSource();
                    this.cdr.detectChanges();
                } else {
                    this.loadDocumentSettings(); // Fallback
                }
            },
            error: (err) => {
                // En cas d'erreur, utiliser les autres sources (initialSettings ou localStorage)
                this.loadDocumentSettings();
            }
        });
    }


    private calculateDateValueFromEcheance(dateEcheance: string): void {
        if (!dateEcheance) return;
        
        const today = new Date();
        const echeanceDate = new Date(dateEcheance);
        const diffTime = echeanceDate.getTime() - today.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        if (diffDays > 0) {
            if (diffDays < 30) {
                this.dateValue = diffDays;
                this.dateFrequency = DateEcheanceFrequency.JOURS;
            } else if (diffDays < 365) {
                const diffMonths = Math.floor(diffDays / 30);
                this.dateValue = diffMonths;
                this.dateFrequency = DateEcheanceFrequency.MOIS;
            } else {
                const diffYears = Math.floor(diffDays / 365);
                this.dateValue = diffYears;
                this.dateFrequency = DateEcheanceFrequency.ANNEE;
            }
        }
    }

    private syncSettingsFromDocument(docSettings: any): void {
        // Mapper les valeurs depuis documentColumnSettings vers documentSettings
        this.documentSettings = {
            reference: docSettings.reference ?? docSettings.référence ?? true,  // Par défaut true pour nouveau document
            // Exigence métier: checkbox Quantité cochée par défaut.
            quantite: true,
            unite: docSettings.unite ?? docSettings.unité ?? false,
            prixUnitaire: docSettings.prixUnitaire ?? docSettings.prix_unitaire ?? true,
            tva: docSettings.tva ?? true,
            remise: docSettings.remise ?? false,
            afficherMontantsTTC: docSettings.afficherMontantsTTC ?? docSettings.aff_montant_ttc ?? false,
            afficherCodeBarres: docSettings.afficherCodeBarres ?? docSettings.aff_code_bar ?? true,
            afficherDateEcheance: docSettings.afficherDateEcheance ?? docSettings.aff_date_echeance ?? docSettings.aff_date_échéance ?? false,
            afficherDateLivraison: docSettings.afficherDateLivraison ?? docSettings.aff_date_liv ?? true,
            afficherMontantTotal: docSettings.afficherMontantTotal ?? docSettings.aff_montant_total ?? true,
            afficherCoordonneesClients: docSettings.afficherCoordonneesClients ?? docSettings.aff_coordonnees ?? docSettings.aff_coordonnées ?? true,
        };
        this.cdr.detectChanges();
    }

    ngAfterViewInit(): void {
        feather.replace();
    }

    private checkRoute(): void {
        const currentUrl = this.router.url;
        this.isApprovePage =
            currentUrl.includes('/vente-negoce/devis/validation') ||
            currentUrl.includes('/vente-negoce/commande-client/action/validation') ||
            currentUrl.includes('/vente-negoce/bon-sortie/action/validation') ||
            currentUrl.includes('/vente-negoce/bon-livraison/action/validation') ||
            currentUrl.includes('/vente-negoce/facture/action/validation');
        this.cdr.detectChanges();
    }

    loadTaxes(): void {
        if (!this.stationId) {
            this.toastr.error('Aucun station_id trouvé. Veuillez vous connecter.', 'Erreur');
            this.isLoadingTaxes = false;
            this.taxes = [];
            this.cdr.detectChanges();
            return;
        }

        this.isLoadingTaxes = true;

        this.taxeService.getTaxeList(this.stationId).subscribe({
            next: (response) => {
                // Récupère toutes les taxes
                const allTaxes = response.taxes  || [];

                // FILTRAGE : on garde seulement celles qui ne sont PAS appliquées sur les produits
                this.taxes = allTaxes.filter((taxe: Taxe) =>
                    taxe.taxe_applique_sur_produits === false ||
                    taxe.taxe_applique_sur_produits === null
                );

                this.isLoadingTaxes = false;
                this.cdr.detectChanges();
            },
            error: (err) => {
                this.isLoadingTaxes = false;
                this.taxes = [];
                this.toastr.error('Erreur lors du chargement des taxes.', 'Erreur');
                this.cdr.detectChanges();
            }
        });
    }

    openSettingsPanel(): void {
        this.isSettingsPanelOpen = true;
        this.activeTab = 'document';
        setTimeout(() => feather.replace(), 0);
    }

    closeSettingsPanel(): void {
        this.isSettingsPanelOpen = false;
    }

    setActiveTab(tab: 'document' | 'taxe' | 'devise'): void {
        this.activeTab = tab;
        setTimeout(() => feather.replace(), 0);
    }

    filterCurrencies(): void {
        if (!this.currencySearch) {
            this.filteredCurrencies = [...this.currencies];
        } else {
            const searchTerm = this.currencySearch.toLowerCase();
            this.filteredCurrencies = this.currencies.filter(
                (currency) =>
                    currency.code.toLowerCase().includes(searchTerm) ||
                    currency.name.toLowerCase().includes(searchTerm)
            );
        }
    }

    incrementPaymentPeriod(): void {
        this.dateValue = (this.dateValue || 1) + 1;
        // Recalculer date_echeance quand dateValue change
        this.onDocumentSettingChange();
    }

    decrementPaymentPeriod(): void {
        if (this.dateValue > 1) {
            this.dateValue -= 1;
            // Recalculer date_echeance quand dateValue change
            this.onDocumentSettingChange();
        }
    }

    validateStep4(): void {
        if (this.dateValue < 1) {
            this.dateValue = 1;
        }
        // Recalculer date_echeance après validation
        this.onDocumentSettingChange();
    }

    /**
     * Appelé quand la fréquence (jours/mois/années) change
     */
    onDateFrequencyChange(): void {
        // S'assurer que dateFrequency est correctement converti en enum si c'est une string
        if (typeof this.dateFrequency === 'string') {
            if (this.dateFrequency === 'jours') {
                this.dateFrequency = DateEcheanceFrequency.JOURS;
            } else if (this.dateFrequency === 'mois') {
                this.dateFrequency = DateEcheanceFrequency.MOIS;
            } else if (this.dateFrequency === 'annee' || this.dateFrequency === 'années') {
                this.dateFrequency = DateEcheanceFrequency.ANNEE;
            }
        }
        // Recalculer date_echeance avec la nouvelle fréquence
        this.onDocumentSettingChange();
    }

    saveSettings(): void {
        // Mapper les valeurs vers le format attendu par DocumentComponent (avec les noms d'attributs backend)
        const settingsToSave: any = {
            // Noms frontend
            reference: this.documentSettings.reference,
            quantite: this.documentSettings.quantite,
            unite: this.documentSettings.unite,
            prixUnitaire: this.documentSettings.prixUnitaire,
            tva: this.documentSettings.tva,
            remise: this.documentSettings.remise,
            afficherMontantsTTC: this.documentSettings.afficherMontantsTTC,
            afficherCodeBarres: this.documentSettings.afficherCodeBarres,
            afficherDateEcheance: this.documentSettings.afficherDateEcheance,
            afficherDateLivraison: this.documentSettings.afficherDateLivraison,
            afficherMontantTotal: this.documentSettings.afficherMontantTotal,
            afficherCoordonneesClients: this.documentSettings.afficherCoordonneesClients,
            // Noms backend (pour la sauvegarde) - sans accents
            aff_montant_ttc: this.documentSettings.afficherMontantsTTC,
            aff_code_bar: this.documentSettings.afficherCodeBarres,
            aff_date_echeance: this.documentSettings.afficherDateEcheance,
            aff_date_liv: this.documentSettings.afficherDateLivraison,
            aff_montant_total: this.documentSettings.afficherMontantTotal,
            aff_coordonnees: this.documentSettings.afficherCoordonneesClients,
            prix_unitaire: this.documentSettings.prixUnitaire
            // Note: reference, quantite, unite, tva et remise sont déjà définis plus haut (noms frontend)
        };
        

        // Sauvegarder dans localStorage
        try {
            localStorage.setItem('documentColumnSettings', JSON.stringify(settingsToSave));

            // Vérifier que la sauvegarde a bien fonctionné
            const saved = localStorage.getItem('documentColumnSettings');
            if (saved) {
               // console.log('✅ [saveSettings] Vérification - Données sauvegardées:', JSON.parse(saved));
            } else {
                console.error('❌ [saveSettings] ERREUR - Aucune donnée trouvée dans localStorage après sauvegarde');
            }
        } catch (error) {
            this.toastr.error('Erreur lors de la sauvegarde des paramètres', 'Erreur');
            return;
        }
        
        // Émettre les changements vers DocumentComponent pour mise à jour immédiate
        const settingsToEmit = {
            reference: this.documentSettings.reference,
            quantite: this.documentSettings.quantite,
            unite: this.documentSettings.unite,
            prixUnitaire: this.documentSettings.prixUnitaire,
            tva: this.documentSettings.tva,
            remise: this.documentSettings.remise,
            afficherMontantsTTC: this.documentSettings.afficherMontantsTTC,
            afficherCodeBarres: this.documentSettings.afficherCodeBarres,
            afficherDateEcheance: this.documentSettings.afficherDateEcheance,
            afficherDateLivraison: this.documentSettings.afficherDateLivraison,
            afficherMontantTotal: this.documentSettings.afficherMontantTotal,
            afficherCoordonneesClients: this.documentSettings.afficherCoordonneesClients,
        };
        

        // Émettre les changements pour mettre à jour DocumentComponent immédiatement
        this.documentSettingsChange.emit(settingsToEmit);
        
        // Forcer la détection des changements
        this.cdr.detectChanges();
        
        // Afficher un message de succès

    }

    openDetailModal() {
        if (this.fileUploadModal) {
            this.fileUploadModal.openModal();
        } else {
           // console.error('FileUploadModalNegoceComponent is undefined');
        }
    }

    openImportQRModal() {
        if (this.importQRModal) {
            this.importQRModal.openModal();
        } else {
            //console.error('ImportQRModalComponent is undefined');
        }
    }

    openCachetModal(content: TemplateRef<any>) {
        if (this.cachetModal) {
            this.modalRef = this.modalService.open(this.cachetModal, { centered: true });
        } else {
            console.error('cachetModal is not defined in ViewChild');
        }
    }

    goToDocumentSettings(modal: NgbModalRef) {
        this.router.navigate(['/main/parametre/document']);
        modal.close();
    }

    openEmailModal() {
        if (this.emailComposeComponent) {
            this.emailComposeComponent.openModal();
        } else {
           // console.error('EmailComposeNegoceComponent is undefined');
        }
    }

    editCurrency(currency: any) {
      //  console.log('editCurrency:', currency);
    }

    /** true = taxe globale (PUT API) ; false = réglage réservé au document courant (pas de PUT). */
    private isAppliqueSurTousDocuments(tax: Taxe): boolean {
        const v = (tax as any).applique_sur_tous_document;
        if (v === false || v === 0 || v === '0') {
            return false;
        }
        return true;
    }

    /** État affiché pour l’interrupteur : paramètre global ou override document. */
    getEffectiveTaxStatut(tax: Taxe): boolean {
        if (!this.isAppliqueSurTousDocuments(tax)) {
            const ov = this.taxStatutDocumentOverrides?.[tax.id];
            if (ov !== undefined) {
                return !!ov;
            }
        }
        const s = (tax as any).statut;
        return s === true || s === 1 || s === '1' || s === 'true';
    }

    onTaxToggle(event: Event, tax: Taxe): void {
        const checkbox = event.target as HTMLInputElement;
        const newStatus = checkbox.checked;

        if (!this.stationId) {
            this.toastr.error('Aucune station trouvée. Veuillez vous reconnecter.');
            checkbox.checked = !newStatus;
            return;
        }

        // Taxe « document uniquement » : pas de PUT, uniquement l’état local du document
        if (!this.isAppliqueSurTousDocuments(tax)) {
            this.documentTaxStatutChange.emit({ taxId: tax.id, statut: newStatus });
            this.toastr.success(
                `Taxe "${tax.label}" : ${newStatus ? 'activée' : 'désactivée'} pour ce document uniquement.`
            );
            this.cdr.detectChanges();
            return;
        }

        // Comportement normal : mise à jour globale (PUT)
        tax.statut = newStatus;

        this.taxeService.updateTaxe(tax, this.stationId).subscribe({
            next: (response) => {
                if (response.success) {
                    this.toastr.success(`Taxe "${tax.label}" ${newStatus ? 'activée' : 'désactivée'} avec succès.`);
                    this.taxesUpdated.emit();
                } else {
                    this.toastr.error(response.message || 'Échec de la mise à jour de la taxe.');
                    tax.statut = !newStatus;
                    checkbox.checked = !newStatus;
                }
                this.cdr.detectChanges();
            },
            error: (err) => {
                this.toastr.error('Erreur lors de la mise à jour de la taxe.');
                tax.statut = !newStatus;
                checkbox.checked = !newStatus;
                this.cdr.detectChanges();
            }
        });
    }

    onDocumentSettingChange() {
        const settingsToEmit = {
            reference: this.documentSettings.reference,
            quantite: this.documentSettings.quantite,
            unite: this.documentSettings.unite,
            prixUnitaire: this.documentSettings.prixUnitaire,
            tva: this.documentSettings.tva,
            remise: this.documentSettings.remise,
            afficherMontantsTTC: this.documentSettings.afficherMontantsTTC,
            afficherCodeBarres: this.documentSettings.afficherCodeBarres,
            afficherDateEcheance: this.documentSettings.afficherDateEcheance,
            afficherCoordonneesClients: this.documentSettings.afficherCoordonneesClients,
            afficherMontantTotal: this.documentSettings.afficherMontantTotal,
            afficherDateLivraison: this.documentSettings.afficherDateLivraison,
            // color, label, date_echeance (fréquence) et nbr_date dans parametrage_doc
            parametrage_doc: {
                color: this.primaryColor,
                label: this.documentType || this.label,
                date_echeance: String(this.dateFrequency || DateEcheanceFrequency.JOURS), // Fréquence sélectionnée: jours, mois, ou annee (converti en string pour l'API)
                nbr_date: this.dateValue
            }
        };
        this.documentSettingsChange.emit(settingsToEmit);
    }

    onColorChange(): void {
        this.primaryColorChange.emit(this.primaryColor);
        // Également émettre dans documentSettingsChange pour mettre à jour le document
        this.onDocumentSettingChange();
    }

    onDownloadPDFClick(): void {
        this.downloadPDFRequest.emit();
    }




}
